import styled from "styled-components";

export const MainContent = styled.div`
  padding: 20px;
  margin-right: auto;
  margin-left: auto;
  max-width: 950px;
`;

export const PowerBIContainer = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 47.5%; /* Aspect ratio based on 1140x541.25 (541.25/1140 = 0.475) */
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;
